import {PropertySectionItem} from 'common/query-builder/query-block/properties-menu/item-menu-types';
import {QueryEventEntry} from 'common/query-builder/query-entry-section/types';
import {ResizedColumnWidths} from 'common/components/table/types';
import {InspectorEvent} from 'common/report/queries/query-api/inspector';

export enum PropertyKeyFilter {
  AllProperties = `All Properties`,
  YourProperties = `Your Properties`,
  MixpanelProperties = `Mixpanel Properties`,
}

export enum ViewFormat {
  Table = `table`,
  Json = `json`,
}

export type ColumnWidths = {[propertyName: string]: number};

export type InspectorAppState = {
  // TODO @jimmy: properly type this
  bookmark: string;
  colWidths: ResizedColumnWidths;
  entries: QueryEventEntry[];
  filters: any[];
  filtersOperator: string;
  dateRange: any;
  events: InspectorEvent[];
  totalCount: number;
  limit: number;
  loading: boolean;
  loadingBookmarkUrl: boolean;
  loadingMore: boolean;
  error: any;
  showQueryBuilder: boolean;
  lastRefreshed: string;
  hasReceivedEvents: boolean;
  propertyKeyFilter: PropertyKeyFilter;
  viewFormat: ViewFormat;
  search: string;
  isSearchInputExpanded: boolean;
  selectedProperties: PropertySectionItem[];
  selectedDistinctId: string;
  selectedRowIdx: number;
  sentinelEvent: InspectorEvent;
  isQuerySamplingEnabled: boolean;
};

export type ViewInInsightsClickEvent = CustomEvent<{eventName: string}>;
export type ViewInLexiconClickEvent = CustomEvent<{eventName: string}>;
export type ProfileIconClickEvent = CustomEvent<{distinctId: string; rowIdx: number}>;
